<template>
    <div class="login__form">
        <p class="login__form-message" :class="{ 'error': hasError }">{{ responseMessage }}</p>
        <div class="field">
            <label for="identifier">{{ dictionary.LoginIdentifierLabel }}</label>
            <InputText v-model="identifier" id="identifier" name="identifier" />
        </div>
        <div class="field" v-if="showCodeField">
            <label for="code">{{ dictionary.LoginCodeLabel }}</label>
            <InputText type="number" v-model="code" id="code" name="code" />
        </div>

        <Button class="p-button-primary p-button-rounded"
            :disabled="(!identifier) || (!code && showCodeField)" id="loginButton"
            v-on:click="handleLoginAction">{{ dictionary.LoginButtonLabel }}</Button>
    </div>
</template>
<script>
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";

export default {
    name: "login",
    props: ["redirect", "initialIdentifier"],
    components: {
        Button,
        InputText,
        InputNumber,
    },
    data() {
        return {
            dictionary: {},
            identifier: null,
            code: null,
            responseMessage: null,
            hasError: false,
            showCodeField: false
        };
    },
    created() {
        const vm = this;
        if (vm.initialIdentifier) {
            vm.identifier = vm.initialIdentifier;
            vm.handleLoginAction();
        }
        fetch("/umbraco/api/dictionaryapi/GetLoginDictionary").then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    methods: {
        handleLoginAction() {
            const vm = this;
            vm.toggleSpinner(true);

            if (vm.identifier != null && vm.code == null && !vm.showCodeField) {
                fetch("/umbraco/api/LoginApi/RequestLoginCode", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ identifier: vm.identifier })
                }).then((response) => {
                    if (response.ok) {
                        return response.text()
                    } else {
                        return response.text().then(text => {throw new Error(text)});
                    }
                })
                    .then((data) => {
                        vm.responseMessage = data;
                        vm.hasError = false;
                        vm.showCodeField = true;
                        vm.toggleSpinner(false);

                    }).catch((error) => {
                        vm.responseMessage = error;
                        vm.hasError = true;
                        vm.toggleSpinner(false);

                        return false;
                    });
            } else if (vm.identifier != null && vm.code != null & vm.showCodeField) {
                fetch("/umbraco/api/LoginApi/VerifyCodeAndLoginUser", {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({ identifier: vm.identifier, code: vm.code })
                }).then(response => {
                    if (response.ok) {
                        return response.text();
                    } else {
                        return response.text().then(text => {throw new Error(text)});
                    }
                })
                    .then(data => {
                        window.dataLayer.push({
                            'customerId': data,
                        });
                        vm.toggleSpinner(false);

                        if (vm.redirect) {
                            window.location.href = "https://booking.nettolager.dk";
                        } else {
                            vm.$emit('loggedIn');
                        }
                    }).catch(error => {
                        vm.responseMessage = error;
                        vm.hasError = true;
                        vm.toggleSpinner(false);
                        return false;
                    });
            }
        },
        toggleSpinner: function (isLoading) {
            this.isLoading = isLoading;
            if (isLoading) {
                $("body").addClass("is-loading");
            } else {
                $("body").removeClass("is-loading");
            }
        },
    }
};
</script>
